import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconForwardToInbox.tsx
const OutlinedFilledForwardToInbox = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m785-16-51-52 65-67H594v-75h205l-66-66 52-53 157 157L785-16ZM149-135q-40.05 0-67.03-26.98Q55-188.95 55-229v-502q0-40.46 26.97-67.73Q108.95-826 149-826h662q40.46 0 67.73 27.27Q906-771.46 906-731v358q-28.1-15-57.58-23-29.49-8-60.42-8-105.75 0-179.87 73.5Q534-257 534-152v17H149Zm331-296 331-217v-83L480-518 149-731v83l331 217Z" })
});
const OutlinedForwardToInbox = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480-436 149-653v424h385v94H149q-39.05 0-66.53-27.48Q55-189.95 55-229v-502q0-39.46 27.47-67.23Q109.95-826 149-826h662q39.46 0 67.23 27.77Q906-770.46 906-731v327h-95v-249L480-436Zm0-82 331-213H149l331 213ZM785-16l-51-52 65-67H594v-75h205l-66-66 52-53 157 157L785-16ZM149-653v501-252 3-330 78Z" })
});
const RoundedFilledForwardToInbox = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M799-135H631q-15.72 0-26.36-10.69-10.64-10.7-10.64-26.5Q594-188 604.64-199q10.64-11 26.36-11h168l-40-40q-11-11-11-26t11-26q11-12 26.5-11.5t26.71 11.71L908-206q7 7 10.5 16.05 3.5 9.04 3.5 17.95 0 9-3.5 17.5T908-138l-95.81 95.81Q800-30 785.1-30.5T759-43q-11-11-11-25t11-26l40-41Zm-650 0q-40.05 0-67.03-26.98Q55-188.95 55-229v-502q0-40.46 26.97-67.73Q108.95-826 149-826h662q40.46 0 67.73 27.27Q906-771.46 906-731v295q0 22.16-18.5 34.08Q869-390 848-397q-14.94-4.45-29.97-5.73Q803-404 788.21-404q-105.84 0-180.02 73.5Q534-257 534-152q0 7-5.36 12T517-135H149Zm331-383L203-696q-17-11-35.5-1.25T149-666q0 9.25 4.5 16.12Q158-643 165-638l289 190q12 8 26 8t26-8l289-190q7-5 11.5-11.82t4.5-16Q811-687 792.5-697t-35.5 1L480-518Z" })
});
const RoundedForwardToInbox = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M811-731H149v502h338q19.75 0 33.38 13.68Q534-201.65 534-181.82q0 19.82-13.62 33.32Q506.75-135 487-135H149q-39.05 0-66.53-27.48Q55-189.95 55-229v-502q0-39.46 27.47-67.23Q109.95-826 149-826h662q39.46 0 67.23 27.77Q906-770.46 906-731v280q0 19.75-14.26 33.37-14.27 13.63-34 13.63-19.74 0-33.24-13.63Q811-431.25 811-451v-280Zm-662 0v502-175 3-330Zm331 218 331-218v78L506-448q-11.75 8-25.87 8-14.13 0-26.13-8L149-646v-85l331 218Zm319 378H631q-15.72 0-26.36-10.69-10.64-10.7-10.64-26.5Q594-188 604.64-199q10.64-11 26.36-11h168l-40-40q-11-11-11-26t11-26.39q11-11.61 26.5-11.11t26.71 11.71L908-206q7 7 10.5 16.14 3.5 9.13 3.5 17.86 0 9-3.5 17.5T908-138l-95.81 95.81Q800-30 785.1-30.5t-26.23-12.63Q748-54 748-68q0-14 11-26l40-41Z" })
});
const SharpFilledForwardToInbox = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m785-16-51-52 65-67H594v-75h205l-66-66 52-53 157 157L785-16ZM55-135v-691h851v453q-28.1-15-57.52-23T788-404q-106.17 0-180.08 73.71Q534-256.58 534-152v17H55Zm425-296 331-217v-83L480-518 149-731v83l331 217Z" })
});
const SharpForwardToInbox = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480-436 149-653v424h385v94H55v-691h851v422h-95v-249L480-436Zm0-82 331-213H149l331 213ZM785-16l-51-52 65-67H594v-75h205l-66-66 52-53 157 157L785-16ZM149-653v501-252 3-330 78Z" })
});
const componentMap = {
	outlined: OutlinedForwardToInbox,
	"outlined-fill": OutlinedFilledForwardToInbox,
	rounded: RoundedForwardToInbox,
	"rounded-fill": RoundedFilledForwardToInbox,
	sharp: SharpForwardToInbox,
	"sharp-fill": SharpFilledForwardToInbox
};
const IconForwardToInbox = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconForwardToInbox };